<template>
    <div class="main-dangerzone">
        <v-container>
            <v-row>
                <v-col>
                    <h1>Danger Zone Time Sheet | เวลาปัจจุบัน <span>{{currentTime}}</span></h1>
                </v-col>
                <v-col cols="1">
                    <button
                            class="btn-alarm"
                            @click="buttonAlert()"
                            >กดเพื่อปิดไฟ</button>
                </v-col>
            </v-row>
        </v-container>
        <br>
     <table class="table-dangerzone">
        <thead>
            <tr>
                <th style="width: 5%;">รูปพนักงาน</th>
                <th style="width: 5%;">เหลือเวลา</th>
                <th style="width: 5%;">เกินเวลา</th>
                <th style="width: 10%;">เวลาเข้า 🠗</th>
                <th style="width: 10%;">เวลาออก ↑</th>
                <th style="width: 2%;">รหัสพนักงาน</th>
                <th style="width: 15%;">ชื่อ-นามสกุล</th>
                <th style="width: 10%;">แผนก</th>
                <th style="width: 15%;">หน้าที่</th>
                <th style="width: 10%;">จัดการ</th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr v-for="n in 10" :key="n">
                <th>รูปพนักงาน</th>
                <th>เหลือเวลา</th>
                <th>เกินเวลา</th>
                <th>เวลาเข้า 🠗</th>
                <th>เวลาออก ↑</th>
                <th>รหัสพนักงาน</th>
                <th>ชื่อ-นามสกุล</th>
                <th>แผนก</th>
                <th>หน้าที่</th>
                <th>จัดการ</th>
            </tr> -->
            <tr v-for="(item, index) in attendanceList"
            :key="item.employee_no"
            :class="{
                'slide-in': true,
                'blink-yellow': item.employee__dangerzone_time_blink
            }"
            :style="{ '--i': index }">
                <th><img :src="getImage(item.image)" class="profile-img"></th>
                <th
                :class="{
                    'time-remain': !item.employee__dangerzone_time_blink
                }">
                    {{ getTimeLeft(item.timeRemain, item.time_left) }}</th>
                <th
                :class="{
                    'time-remain': !item.employee__dangerzone_time_blink
                }">
                    {{ getTimeOver(item.timeRemain, item.time_left) }}</th>
                <th>{{ item.checkin_time}}</th>
                <th>{{ item.checkout_time}}</th>
                <th>{{ item.employee_no}}</th>
                <th>{{ item.name}}</th>
                <th>{{ item.department}}</th>
                <th>{{ item.job}}</th>
                <th><button
                            class="btn-remove"
                            @click="deleteRecord(item.id)"
                            >ลบรายการ</button></th>
              </tr>
        </tbody>
     </table>
    </div>
</template>

<script>
import Vue from 'vue'
import Notifications from 'vue-notification'
import profileDefault from '@/assets/user_default.png'
import axios from 'axios'

Vue.use(Notifications)

export default {

    name: 'DangerZoneTimeSheet',

    components: {
    },

    data () {
        return {
            loading: false,
            attendanceList: [],
            pageCount: 1,
            page: 1,
            options: {},
            search: '',
            startDate: this.$util.getCurrentDate(),
            endDate: this.$util.getCurrentDate(),
            startDatePickerShow: false,
            endDatePickerShow: false,
            startDateFormatted: '',
            endDateFormatted: '',
            attendanceStatus: null,
            attendanceStatusItem: [],
            exportForm: {
                search: null,
                startDate: null,
                endDate: null,
                attendanceStatus: null
            },
            branch: null,
            isEISAttendance: process.env.VUE_APP_EIS_ATTENDANCE,
            currentTime: null,
            isAlarm: true
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },
    methods: {
        async getAttendancesList () {
            const url = `${process.env.VUE_APP_BACKEND}/time-dashboard`
            const res = await axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.attendanceList = res.data.data
            }
            this.calculateDangerZoneTimeRemain(this.attendanceList)
            this.loading = false
        },
        async getAttendanceStatus () {
            const url = `${process.env.VUE_APP_BACKEND}/time-dashboard`
            const res = await axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.attendanceStatusItem = res.data.attendance_status
            }
        },
        getTimeLeft (timeRemain, timeLeft) {
            // console.log(timeLeft)
            return timeLeft > 0 ? timeRemain : '00:00'
        },
        getTimeOver (timeRemain, timeLeft) {
            // console.log(timeLeft)
            return timeLeft <= 0 ? timeRemain : '00:00'
        },
        getImage (imageLink) {
            if (imageLink) {
                return imageLink
            }

            return profileDefault
        },
        parseTime (timeStr) {
            if (typeof timeStr !== 'string') {
                throw new TypeError('Expected a string in the format "HH:MM:SS"')
            }

            const timeParts = timeStr.split(':')
            if (timeParts.length !== 3) {
                throw new Error('Invalid time format. Expected "HH:MM:SS"')
            }

            const [hours, minutes, seconds] = timeParts.map(Number)
            if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
                throw new Error('Invalid time components. Expected numbers')
            }
            return new Date(1970, 0, 1, hours, minutes, seconds)
        },
        getTimeDifference (startTime, endTime) {
            const diff = (endTime - startTime)
            return diff
        },
        getTimeOut (startDate, quotaTime) {
            const endDate = new Date(startDate)
            endDate.setMinutes(startDate.getMinutes() + quotaTime)
            return endDate
        },
        updateCurrentTime () {
            const now = new Date()
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            this.currentTime = `${hours}:${minutes}:${seconds}`
            if (seconds === '01' || seconds === '21' || seconds === '41') {
                this.refreshTable()
            }
            this.calculateDangerZoneTimeRemain(this.attendanceList)
        },
        calculateDangerZoneTimeRemain (attendanceList) {
            const nowAll = new Date()
            const now = new Date(1970, 0, 1, nowAll.getHours(), nowAll.getMinutes(), nowAll.getSeconds())
            const nowMinute = new Date(1970, 0, 1, nowAll.getHours(), nowAll.getMinutes())

            attendanceList.forEach(attendance => {
                const timeIn = this.parseTime(attendance.checkin_time)
                const timeLimit = this.getTimeOut(nowMinute, attendance.time_left)
                let timeOut
                let timeRemain
                // attendance.time_left : format of minute (ex: 1.00023) from API (update per minute)
                if (attendance.checkout_time !== '00:00:00') {
                    // out of dangerzone
                    timeOut = this.parseTime(attendance.checkout_time)
                    if (timeOut < timeLimit) {
                        // overtime checkout
                        timeRemain = this.timeRemainFomating(this.getTimeDifference(timeOut, timeLimit))
                    } else if (timeOut >= timeLimit) {
                        timeRemain = this.timeRemainFomating(this.getTimeDifference(timeIn, timeOut))
                    }
                    attendance.employee__dangerzone_time_blink = false
                } else {
                    // overtime
                    if (now > timeLimit) {
                        timeRemain = this.timeRemainFomating(this.getTimeDifference(timeLimit, now))
                        attendance.employee__dangerzone_time_blink = true
                    } else {
                        timeRemain = this.timeRemainFomating(this.getTimeDifference(now, timeLimit))
                    }
                }
                attendance.timeRemain = timeRemain
            })
        },
        timeRemainFomating (timeRemain) {
            const totalSeconds = Math.floor(timeRemain / 1000)
            const minutes = Math.floor(totalSeconds / 60)
            const seconds = totalSeconds % 60
            const formattedMinutes = String(minutes).padStart(2, '0')
            const formattedSeconds = String(seconds).padStart(2, '0')
            return `${formattedMinutes}:${formattedSeconds}`
        },
        async getBranch () {
            this.branch = true
            if (this.branch) {
                await this.getAttendancesList()
            }
        },
        goToLocationDetails (checkInLocationId) {
            this.$router.push({ name: 'CheckInLocationDetail', params: { id: checkInLocationId } }, () => {})
        },
        errorModal (message) {
            this.$emit('errorModal', message)
        },
        async buttonAlert () {
            try {
                const url = `${process.env.VUE_APP_BACKEND}/alarm/off`
                const res = await axios.get(url)
                if (res?.data?.status === 'ok') {
                    this.$notify({
                        title: 'ปิดสัญญาไฟ',
                        text: 'คุณทำการ "ปิด" สัญญาไฟแจ้งเตือนการเข้าออกพื้นที่อันตราย',
                        type: 'warn'
                    })
                }
            } catch (error) {
                this.$notify({
                    title: 'Error!',
                    type: 'error',
                    max: 2
                })
            }
        },
        async deleteRecord (id) {
            try {
                const url = `${process.env.VUE_APP_BACKEND}/roominout/${id}/clear`
                const res = await axios.delete(url, {})
                if (res?.data?.status === 'ok') {
                    this.$notify({
                        title: 'ลบรายการ',
                        text: 'คุณทำการ "ลบรายการ"',
                        type: 'success'
                    })
                }
                this.refreshTable()
            } catch (error) {
                this.$notify({
                    title: 'Error!',
                    type: 'error'
                })
            }
        },
        refreshTable () {
            this.getAttendancesList()
            location.reload()
        }
    },

    async mounted () {
        setInterval(this.updateCurrentTime, 1000)
        await this.getBranch()
        await this.getAttendanceStatus()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getAttendancesList()
                }
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function () {
                if (this.branch) {
                    await this.getAttendancesList()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.main-dangerzone {
    display:block;
    height: 100vh;
    padding: 0.5rem;
    background-color: #232234;
    color: white;
    overflow-y: auto;
}

.main-dangerzone::-webkit-scrollbar{
    display: none;
}
.main-dangerzone {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

@keyframes blink {
    0%, 100% {
        background-color: #FFA202;
    }
    50% {
        background-color: transparent;
    }
}

.red-bg {
    background-color: red !important;
}

.table-dangerzone {
    overflow: auto;
    font-weight: 100 !important;
    text-align: center;
    border: 2px solid #1B5DFA;
    border-collapse: collapse;

    thead {
        tr {
            background-color: #1B5DFA;
        }

        th {
            height: 3rem;
            padding: 1rem;
            background-color: #1B5DFA;
        }
    }

    tbody {
        tr {
            animation: slideIn 0.5s ease-out;
            animation-delay: calc(var(--i) * 0.2s);

            &.blink-yellow {
                animation: blink 1s infinite;
            }

            &:last-child th {
                border-bottom-width: 2px;
            }

            th {
                border: 1px dashed #1B5DFA;
                height: 3rem;
                padding: 1rem;
                font-size: large;

                &:first-child {
                    border-left-width: 2px;
                    padding: 0;
                    justify-content: center;
                    align-content: center;
                }

                &:last-child {
                    border-right-width: 2px;
                }
            }
        }
    }

    .profile-img {
        display: block;
        margin: 0 auto;
        max-width: 90%;
        height: auto;
        border-radius: 20%;
        padding: 5%;
        box-sizing: border-box;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.time-remain{
    background-color:#28433E;
    color: #4DC167;
}

.time-overtime{
    background-color:#b9313162;
    color: #b93131;
}

.btn-alarm{
    width: 100%;
    padding: 1rem;
    border-radius: 20px;
    color: white;
    background-color: red;
}

.btn-remove{
    width: 100%;
    padding: 1rem;
    border-radius: 20px;
    color: white;
    background-color: red;
}
</style>
